function formTypeSelect(e) {

    const select = e.target.closest('#input_3_12');
    if (!select) return;

    const value = select.value;

    const companyMail = document.querySelector('.contact_content_company_info_item_mail');
    const companyMailRh = document.querySelector('.contact_content_company_info_item_mail_rh');

    // on reset uniquement les deux blocs concernés
    companyMail?.classList.add('d-none');
    companyMailRh?.classList.add('d-none');

    if (value === 'job') {
        companyMailRh?.classList.remove('d-none');
    }

    if (value === 'contact') {
        companyMail?.classList.remove('d-none');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const select = document.querySelector('#input_3_12');
    if (select) {
        formTypeSelect({ target: select });
    }
});

document.addEventListener('change', function(e) {
    formTypeSelect(e);
});